import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Github,
} from "lucide-react";

export default function LandingFooter() {
  return (
    <>
      <footer className="bg-gray-900 text-white ">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4 text-indigo-600">
                About HackTheWay
              </h3>
              <p className="text-sm text-gray-400">
                HackTheWay is the ultimate platform for cybersecurity
                enthusiasts, offering CTF challenges, bug bounties, and
                comprehensive learning resources for IT, IoT, and OT security.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4 text-indigo-600">
                Quick Links
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#features"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href="#academy"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Academy
                  </a>
                </li>
                <li>
                  <a
                    href="#events"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Events
                  </a>
                </li>
                <li>
                  <a
                    href="#testimonials"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Testimonials
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4 text-indigo-600">
                Resources
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Documentation
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    FAQ
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Support
                  </a>
                </li>
                <li>
                  <a
                    href="/aboutus"
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    About Us
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4 text-indigo-600">
                Contact Us
              </h3>
              <p className="text-sm text-gray-400 mb-2">
                Email: support@hacktheway.com
              </p>
              <p className="text-sm text-gray-400 mb-4">
                Phone: +91-9619495353
              </p>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Facebook className="h-5 w-5" />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Twitter className="h-5 w-5" />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Linkedin className="h-5 w-5" />
                </a>
                <a
                  href="https://github.com/Hack-The-Way"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Github className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © 2024 HackTheWay. All rights reserved.
            </p>
            <nav className="flex gap-4 mt-4 md:mt-0">
              <a
                className="text-sm text-gray-400 hover:text-white transition-colors"
                href="/termsofservice"
              >
                Terms of Service
              </a>
              <a
                className="text-sm text-gray-400 hover:text-white transition-colors"
                href="#"
              >
                Privacy Policy
              </a>
              <a
                className="text-sm text-gray-400 hover:text-white transition-colors"
                href="#"
              >
                Cookie Policy
              </a>
            </nav>
          </div>
        </div>
      </footer>
    </>
  );
}
